<script>
import Vue from 'vue';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VuejsDialog from 'vuejs-dialog';
import { Translator, $ } from '../../../../VideoJetBundle/Resources/js/common/adapters/legacy-to-modules-adapter';

const FORGET_TYPE_USERNAME = 'username';

Vue.use(VuejsDialog);

new Vue({
  el: '#forget-credentials-app',

  data() {
    return {
      forgetType: $('[name="forgot_credentials[forgetType]"]:checked').val(),
    };
  },

  methods: {
    requestHelp() {
      const messagePart = this.forgetType === FORGET_TYPE_USERNAME
        ? 'Make sure you have entered the correct email address registered with your portal account.'
        : 'Make sure you have entered the correct username (not your email address) registered with your portal account'
      ;
      const messageParts = [
        Translator.trans('Before requesting help with Username Recovery / Password Reset, please verify the following:'),
        Translator.trans(messagePart),
        Translator.trans('Make sure you have checked all your email folders including Inbox, Spam, and similar folders for a message from <b>workflow_portal@videojet.com</b>'),
      ];
      const message = `
<h2 class="text-center">
  <i class="fa fa-warning warning-icon"></i>
  ${Translator.trans('Attention')}
</h2>

<p>${messageParts[0]}</p>
<ol>
  <li>${messageParts[1]}</li>
  <li>${messageParts[2]}</li>
</ol>`;
      const options = {
        html: true,
        okText: Translator.trans('Continue'),
        cancelText: Translator.trans('Cancel'),
        animation: 'zoom',
        reverse: true,
      };
      this.$dialog
        .confirm(message, options)
        .then(() => $('#support-popup').modal())
        .catch()
      ;
    },
  },
});
</script>

<style lang="less">
  @import "../../../../VideoJetBundle/Resources/css/colors";

  i.warning-icon {
    color: @color-warning;
  }

  .dg-main-content {
    max-width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/VisualCraft/Bundle/VideoJetUserBundle/Resources/js/forgot-credentials/vue.vue